import TagManager from 'react-gtm-module'

export const sendPageView = () => {
	const pagePath = window.location.pathname
	TagManager.dataLayer({
		event: 'pageview',
		page_path: pagePath,
	})
}
